import React, { useId, useState } from 'react';
import { FormGroup } from 'reactstrap';
import { useQuery } from '@tanstack/react-query';
import moment from 'moment';

import { showMsg } from '../services/library';
import MultiRoleDatePicker, { PICKERTYPE_DATERANGE } from '../components/GeneralForm/MultiRoleDatePicker';
import ErrorBoundary from '../components/GeneralForm/ErrorBoundary';
import ReactTable from '../components/GeneralForm/ReactTableComponent/ReactTableContainer';
import PageComponent from '../components/PageComponent';
import SettingsService from '../services/settingService';
import { DATE_FORMAT_YMD } from '../constants/dateFormatsConst';
import CustomCard from '../components/GeneralForm/CustomCard';
import CustomSelect from '../components/GeneralForm/CustomSelect';
import CustomButton from '../components/GeneralForm/CustomButton';
import { downloadExcelByJsonFn } from '../components/GeneralForm/ReactTableComponent/ExportExcel';
import CustomCheckbox from '../components/GeneralForm/CustomCheckbox';
import ReactLightBox from '../components/GeneralForm/ReactLightBox';
import { IMAGE, INSTA360, VIDEO } from '../constants/messageConst';
import Insta360ViewerModal from '../components/insta360/Insta360ViewerModal';

const Kudos = props => {
  const QUERY_KEY = useId();

  const { themeArr } = props;
  const { isLightTheme } = themeArr;
  const [startDate, setStartDate] = useState(moment().toDate());
  const [endDate, setEndDate] = useState(moment().toDate());
  const [selectedDlrs, setSelectedDlrs] = useState(null);
  const [isDownloadExcel, setIsDownloadExcel] = useState(null);
  const [params, setParams] = useState({});
  const [urls, setUrls] = useState([]);
  const [toggler, setToggler] = useState({
    status: false,
    type: IMAGE,
    slide: 0,
    data: {}
  });

  const filterCheckBoxArr = [
    { label: 'Indoor', val: 'indoor', searchField: 'dealer_shoot_location' },
    { label: 'Outdoor', val: 'outdoor', searchField: 'dealer_shoot_location' },
    { label: 'Studio', val: 'studio', searchField: 'dealer_shoot_location' },
    { label: 'Interior Photo', val: 'interior', searchField: 'name_crop' },
    { label: 'Exterior Photo', val: 'exterior', searchField: 'name_crop' }
    // { label: 'Background', val: 'bg', searchField: 'dm_removebg' },
    // { label: 'No Background', val: 'nobg', searchField: 'dm_removebg' }
  ];
  const dlrList = props.activeDealersList.map(d => ({
    label: d.label,
    value: `${d.value}`,
    id: 'dealership_name'
  }));

  const {
    isFetching: isLoaded,
    data: kodosData = [],
    refetch
  } = useQuery({
    queryKey: [QUERY_KEY],
    queryFn: async () => {
      const fromDate = moment(startDate).format(DATE_FORMAT_YMD);
      const toDate = endDate ? moment(endDate).format(DATE_FORMAT_YMD) : null;
      const payload = { fromDate, toDate, dealers: selectedDlrs, ...params };
      // console.log('payload ->>>>>', payload);

      const res = await SettingsService.kudosList(payload);
      let resData = res.data[0];
      return resData.data.map((x, i) => {
        return {
          ...x,
          index_id: i + 1,
          searchName: `${x.veh_name}|${x.name_text}`,
          shotType: x.name_crop === 'i' ? 'Interior' : x.name_crop === 'e' ? 'Exterior' : '-',
          shootLocation:
            x.dealer_shoot_location === 'outdoor'
              ? 'Outdoor'
              : x.dealer_shoot_location === 'indoor'
                ? 'Indoor'
                : '-'
        };
      });
    },
    refetchOnWindowFocus: false
  });

  const openLightBox = (e, detail) => {
    let typeImg = detail.veh_insta360 == 1 ? INSTA360 : IMAGE;
    setUrls([
      {
        src: detail.veh_path,
        alt: detail.name_text,
        type: typeImg,
        thumb_path: detail.veh_path
      }
    ]);
    setToggler({
      status: !toggler.status,
      type: typeImg,
      slide: 0,
      data: { ...detail, veh_path_main: detail.veh_path, parent: `${detail.veh_type}|${detail.veh_name}` }
    });
  };

  const gridOptionKudos = {
    id: 'gridOptionKudos',
    columnDefs: [
      {
        Header: 'Vehicle Name',
        accessor: 'searchName',
        canSort: true,
        minWidth: 80,
        maxWidth: 90,
        canStopColumnResize: true,
        canFilter: true,
        filterType: 'text',
        headerClassName: 'fs-lg-14 pt-0',
        customCellRenderer: params => {
          const detail = params.row.original;
          return (
            <div className="d-flex">
              {/*
              {detail.veh_path ? (
                <div className="mr-2">
                  <img src={detail.veh_path} width="75" />
                </div>
              ) : (
                ''
              )}
              */}
              <div>
                <h6
                  id={`kudos_flexbox${detail.veh_img_id}`}
                  className={`mb-1 ${detail.veh_path ? 'cursor-pointer' : ''}`}
                  onClick={e => openLightBox(e, detail)}
                >
                  {detail.veh_name}
                </h6>
                <span>{detail.name_text}</span>
              </div>
            </div>
          );
        }
      },
      {
        Header: 'Notification Title',
        accessor: 'nt_title',
        canSort: true,
        minWidth: 80,
        maxWidth: 90,
        headerClassName: 'fs-lg-14 pt-0',
        customCellRenderer: params => {
          const detail = params.row.original;
          return (
            <div className="d-flex">
              <span>{detail.nt_title}</span>
            </div>
          );
        }
      },
      {
        Header: `Capture Location`,
        accessor: 'dealer_shoot_location',
        canSort: true,
        minWidth: 50,
        maxWidth: 50,
        headerClassName: 'fs-lg-14 pt-0',
        customCellRenderer: params => {
          const detail = params.row.original;
          return (
            <>
              {detail.shootLocation ? (
                <div className="mb-1">
                  <b className="mr-2">Capture Location: </b>
                  <span>{detail?.shootLocation}</span>
                </div>
              ) : (
                ''
              )}
              <div className="">
                <b className="mr-2">Shot type: </b>
                <span>{detail?.shotType}</span>
              </div>
            </>
          );
        }
      },
      {
        Header: 'Dealership',
        accessor: 'dealership_name',
        canSort: true,
        minWidth: 30,
        maxWidth: 30,
        canFilter: true,
        filterType: 'dropdown',
        headerClassName: 'fs-lg-14 pt-0',
        customCellRenderer: params => {
          const detail = params.row.original;
          return (
            <div className="d-flex">
              <span>{detail.dealership_name}</span>
            </div>
          );
        }
      },
      {
        Header: 'Kudos By',
        accessor: 'kudos_by_user',
        canSort: true,
        minWidth: 30,
        maxWidth: 30,
        headerClassName: 'fs-lg-14 pt-0',
        customCellRenderer: params => {
          const detail = params.row.original;
          return (
            <div className="d-flex">
              <span>{detail.kudos_by_user}</span>
            </div>
          );
        }
      },

      {
        Header: 'Photographer Name',
        accessor: 'photographer',
        canSort: true,
        minWidth: 30,
        maxWidth: 30,
        headerClassName: 'fs-lg-14 pt-0',
        customCellRenderer: params => {
          const detail = params.row.original;
          return (
            <div className="d-flex">
              <span>{detail.photographer}</span>
            </div>
          );
        }
      },
      {
        Header: 'Created Date',
        accessor: 'created_at_sort',
        canSort: true,
        minWidth: 30,
        maxWidth: 30,
        headerClassName: 'fs-lg-14 pt-0',
        customCellRenderer: params => {
          const detail = params.row.original;
          return (
            <div className="d-flex">
              <span>{detail.created_at}</span>
            </div>
          );
        }
      }
    ],
    rowData: kodosData,
    isPagination: { status: false, defaultPageSize: kodosData.length, isShowTotalRecordLabel: true },
    isGlobalSearch: true
  };

  const handleChangeDates = dates => {
    if (!dates) {
      setStartDate(null);
      setEndDate(null);
    } else {
      const [start, end] = dates;
      setStartDate(start);
      setEndDate(end || null);
    }
  };

  const onDealershipFilterChange = e => {
    const value = e && e.length > 0 ? e.map(d => d.value)?.join(',') : null;
    setSelectedDlrs(value);
  };

  const updateCheckBoxFilter = ({ target: { id, checked } }) => {
    setParams(prev => {
      const updated = { ...prev };

      if (checked) {
        updated[id] = 1;
      } else {
        delete updated[id];
      }

      return updated;
    });
  };

  const handleDownloadDealerNotUploadedExcel = async () => {
    try {
      setIsDownloadExcel(true);

      const fromDate = moment(startDate).format(DATE_FORMAT_YMD);
      const toDate = endDate ? moment(endDate).format(DATE_FORMAT_YMD) : null;
      const payload = { fromDate, toDate, dealers: selectedDlrs, ...params };

      const res = await SettingsService.kudosList(payload);
      const response = res.status === true ? res.data[0] : [];
      setIsDownloadExcel(false);
      if (response.data && response.data.length > 0) {
        await downloadExcelByJsonFn({
          jsonData: response.data,
          fileName: `KudosList - ${fromDate} to ${toDate}`,
          replaceSelectedColumnNames: {
            dealership_name: 'Dealership',
            veh_name: 'Vehicle Name',
            veh_path: 'image Url',
            shootLocation: `Capture location`,
            shotType: 'Shot type',
            nt_title: 'Notification Title',
            kudos_by_user: 'Kudos By',
            photographer: 'Photographer Name',
            created_at: 'Kudos Date'
          },
          xlsSheetName: `Vehicle images`
        });
      } else {
        showMsg('No Data found for download', 'error');
      }
    } catch (err) {
      showMsg(err, 'error');
      setIsDownloadExcel(false);
    }
  };

  return (
    <PageComponent isPageHeader={{ isvisible: true, onClick: () => refetch() }}>
      <ErrorBoundary cardtitle="Kudos List">
        <CustomCard
          titleRenderElement={
            <div className="d-flex justify-content-between align-items-top">
              <div className="w-100">
                <FormGroup className="w-100 h-100" style={{ maxWidth: '500px' }}>
                  <CustomSelect
                    options={dlrList}
                    selected={dlrList?.filter(d => selectedDlrs?.split(',').includes(d.value)) || null}
                    onChange={onDealershipFilterChange}
                    className="multi-select"
                    size="md"
                    id="dealer_filter"
                    placeholder="Select Dealer(s)"
                    isMulti
                    isClearable
                  />
                </FormGroup>
              </div>
              <div className="w-100">
                <div className="mb-2 d-flex justify-content-end">
                  <div className="mr-2">
                    <MultiRoleDatePicker
                      selected={startDate}
                      pickerType={PICKERTYPE_DATERANGE}
                      onChange={handleChangeDates}
                      disabled={isLoaded}
                      startDate={startDate}
                      endDate={endDate}
                    />
                  </div>
                  <div className="mr-2">
                    <CustomButton
                      outline
                      size="sm"
                      disabled={isLoaded || isDownloadExcel || !startDate || !endDate}
                      onClick={handleDownloadDealerNotUploadedExcel}
                      title="Download filtered kudos Xls"
                    >
                      {isDownloadExcel ? (
                        <i className="fa fa-spinner fa-pulse " />
                      ) : (
                        <i className="fa fa-solid fa-fw fa-cloud-download " />
                      )}
                    </CustomButton>
                  </div>
                  <div>
                    <CustomButton
                      title="Apply Filter and Refetch Data"
                      size="sm"
                      color="primary"
                      disabled={isLoaded || isDownloadExcel || !startDate || !endDate}
                      onClick={refetch}
                    >
                      Apply Filter
                    </CustomButton>
                  </div>
                </div>
              </div>
            </div>
          }
        >
          <div className="d-flex flex-wrap">
            {filterCheckBoxArr.map(item => (
              <div key={item.val} className="mr-2">
                <CustomCheckbox
                  name={`${item.val}`}
                  inputClassName={isLightTheme ? 'isLight' : 'isDark'}
                  id={`${item.val}`}
                  className=" pr-Warranty Information2"
                  checked={Boolean(params[item.val])}
                  labelName={item.label}
                  onChange={updateCheckBoxFilter}
                />
              </div>
            ))}
          </div>
        </CustomCard>

        <ReactTable isLoaded={isLoaded} gridOption={gridOptionKudos} />
        {toggler?.type === INSTA360 ? (
          <Insta360ViewerModal
            {...props}
            isOpen={toggler.status}
            toggle={instaData =>
              setToggler({ status: !toggler.status, type: INSTA360, slide: 0, data: instaData })
            }
            data={toggler.data}
            handleFlags={props.handleFlags}
          />
        ) : (
          (toggler?.type === IMAGE || toggler?.type === VIDEO) && (
            <>
              <ReactLightBox
                slides={urls}
                startIndex={toggler?.slide}
                open={toggler?.status}
                close={() => setToggler(prevToggler => ({ ...prevToggler, status: false, slide: 1 }))}
                toggler={toggler}
              />
            </>
          )
        )}
      </ErrorBoundary>
    </PageComponent>
  );
};

Kudos.displayName = 'Kudos';
export default Kudos;
